import React from "react";
import { PageTitle } from "../../PageTitle";
import {
  IconModeling,
  IconStrenght,
  IconCheckGreen,
  IconCheckDarkGreen,
  IconWarning,
  IconChart,
  IconBolt,
} from "../../assets/icons/Icon";
import {
  ExtraLargeHeader,
  SectionHeader,
  SectionHeaderSemibold,
  PageSubheader,
  LargeTextLight,
  MediumHeader,
  MediumHeaderSemiold,
  MediumHeaderBold,
  BodyText,
  MediumText,
  BodyTextBold,
} from "../../styles/Typography";
import { scrollToApplication } from "../../hooks/scrollTo";
import { useNavigate } from "react-router-dom";
import ImageGallery from "../../components/ImageGallery/ImageGallery";
import Button from "../../components/Button/Button";
import ApplicationFooter from "../../components/Footer/ApplicationFooter";
import mainPicture from "./pictures/main.png";
import resin from "./pictures/resin.png";
import insulatingComposition1 from "./pictures/insulating-composition-1.jpg";
import insulatingComposition2 from "./pictures/insulating-composition-2.jpg";
import insulatingComposition3 from "./pictures/insulating-composition-3.jpg";
import hydraulics from "./pictures/hydraulics.png";
import pneumatics from "./pictures/pneumatics.png";
import patent1 from "./pictures/patent-1.jpg";
import patent2 from "./pictures/patent-2.png";
import example1 from "./pictures/example-1.png";
import example2 from "./pictures/example-2.png";
import example3 from "./pictures/example-3.png";
import {
  Container,
  MainSection,
  MainTextContainer,
  Heading,
  PicturesLine,
  PicturesColumn,
  MainPicture,
  OuterResinContainer,
  ResinPicture,
  GreyCard,
  GreyCardTextBrake,
  AccentCards,
  AccentCard,
  AccentCardHeading,
  AccentCardHeader,
  AccentCardContent,
  AccentCardValue,
  AccentCardNumber,
  AccentCardTextBreak,
  InsulatingCompositionSection,
  InsulatingCompositionText,
  InsulatingCompositionTextBreak,
  InsulatingCompositionPicturesLine,
  InsulatingCompositionPicture,
  TextLine,
  EquipmentSection,
  EquipmentContainer,
  EquipmentCard,
  EquipmentPicture,
  EquipmentCardTextBox,
  EquipmentCardText,
  EquipmentCardTextline,
  AdvantagesCard,
  Advantage,
  PatentSection,
  Patents,
  Patent,
  PatentInnerContainer,
  PatentTextContainer,
  CTAContainer,
  WorksSection,
  WorkExamples,
  WorkExample,
  WorkExamplePictureContainer,
  WorkExamplePicture,
  WorkExampleInner,
  WorkExampleHeading,
  ExampleBody,
  ProblemHeader,
  SolutionHeader,
  ProblemInnerContainer,
  SolutionInnerGrid,
  SolutionInnerGridThree,
  SolutionInnerContainer,
  StyledLink,
} from "./RepairWorks.styles";

const RepairWorks: React.FC = () => {
  return (
    <Container>
      <PageTitle title="Ремонтно-изоляционные работы — Интеллект-Развитие-Технологии" />
      <MainSection id="repair-and-insulation">
        <MainTextContainer>
          <Heading>
            <SectionHeader>ремонтно-изоляционные работы</SectionHeader>
            <PageSubheader>На уровне пласта и на устье скважины</PageSubheader>
          </Heading>
          <PicturesLine>
            <MainPicture $image={mainPicture}>
              <img
                src={mainPicture}
                alt="ООО ИРТ"
                loading="eager"
                decoding="async"
              />
            </MainPicture>
            <PicturesColumn>
              <OuterResinContainer>
                <ResinPicture $image={resin}>
                  <img
                    src={resin}
                    alt="Полимерная смола ООО ИРТ"
                    loading="eager"
                    decoding="async"
                  />
                </ResinPicture>
                <span>
                  <BodyText>
                    ООО “Интеллект-Развитие-Технологии” проводит
                    ремонтно-изоляционные работы на уровне пласта и на устье
                    скважины любой сложности.
                  </BodyText>
                  <BodyText>
                    В работе применяются{" "}
                    <b>полимерные смолы собственной разработки.</b>
                  </BodyText>
                </span>
              </OuterResinContainer>
              <GreyCard>
                <span>
                  <IconCheckGreen />
                </span>
                <BodyText>
                  Производство изолирующих материалов полностью локализовано:{" "}
                  <GreyCardTextBrake />
                  мы используем только российские материалы.
                </BodyText>
              </GreyCard>
            </PicturesColumn>
          </PicturesLine>
        </MainTextContainer>

        <AccentCards>
          <AccentCard>
            <AccentCardHeading>
              <AccentCardHeader>
                <p>★</p>
                <p>Рекордный показатель</p>
              </AccentCardHeader>
              <MediumText>
                полимерная смола <AccentCardTextBreak />
                собственного производства
              </MediumText>
            </AccentCardHeading>
            <AccentCardContent>
              <AccentCardValue>
                <AccentCardNumber>
                  <ExtraLargeHeader>1628</ExtraLargeHeader>
                  <MediumHeaderSemiold>атм</MediumHeaderSemiold>
                </AccentCardNumber>
                <span>
                  <IconStrenght />
                </span>
              </AccentCardValue>
              <BodyText>
                по прочности <br />
                <br />
              </BodyText>
            </AccentCardContent>
          </AccentCard>

          <AccentCard>
            <AccentCardHeading>
              <AccentCardHeader>
                <p>★</p>
                <p>Рекордный показатель</p>
              </AccentCardHeader>
              <MediumText>
                полимерная смола <AccentCardTextBreak />
                собственного производства
              </MediumText>
            </AccentCardHeading>
            <AccentCardContent>
              <AccentCardValue>
                <AccentCardNumber>
                  <ExtraLargeHeader>0,497</ExtraLargeHeader>
                  <MediumHeaderSemiold></MediumHeaderSemiold>
                </AccentCardNumber>
                <span>
                  <IconModeling />
                </span>
              </AccentCardValue>
              <BodyText>
                по эластичности, <br />
                коэффициент Пуассона
              </BodyText>
            </AccentCardContent>
          </AccentCard>
        </AccentCards>
      </MainSection>

      <InsulatingCompositionSection id="insulating-composition">
        <InsulatingCompositionText>
          <MediumHeader>
            Наша компания производит изолирующие составы{" "}
            <InsulatingCompositionTextBreak />с высокой приникающей
            способностью, работающие при температуре до 140°C.
          </MediumHeader>
        </InsulatingCompositionText>

        <ImageGallery
          images={[
            {
              src: insulatingComposition1,
              alt: "Цементный камень, извлеченный из оборудования для тестирования цементных растворов True Sight разработки ООО “ИРТ”",
            },
            {
              src: insulatingComposition2,
              alt: "Цементный камень, извлеченный из оборудования для тестирования цементных растворов True Sight разработки ООО “ИРТ”",
            },
            {
              src: insulatingComposition3,
              alt: "Цементный камень, извлеченный из оборудования для тестирования цементных растворов True Sight разработки ООО “ИРТ”",
            },
          ]}
        >
          {({ openGallery }) => (
            <InsulatingCompositionPicturesLine>
              <InsulatingCompositionPicture
                $image={insulatingComposition1}
                onClick={() => openGallery(0)}
              >
                <img
                  src={insulatingComposition1}
                  alt="Цементный камень, извлеченный из оборудования для тестирования цементных растворов True Sight разработки ООО “ИРТ”"
                  loading="lazy"
                  decoding="async"
                />
              </InsulatingCompositionPicture>
              <InsulatingCompositionPicture
                $image={insulatingComposition2}
                onClick={() => openGallery(1)}
              >
                <img
                  src={insulatingComposition2}
                  alt="Цементный камень, извлеченный из оборудования для тестирования цементных растворов True Sight разработки ООО “ИРТ”"
                  loading="lazy"
                  decoding="async"
                />
              </InsulatingCompositionPicture>
              <InsulatingCompositionPicture
                $image={insulatingComposition3}
                onClick={() => openGallery(2)}
              >
                <img
                  src={insulatingComposition3}
                  alt="Цементный камень, извлеченный из оборудования для тестирования цементных растворов True Sight разработки ООО “ИРТ”"
                  loading="lazy"
                  decoding="async"
                />
              </InsulatingCompositionPicture>
            </InsulatingCompositionPicturesLine>
          )}
        </ImageGallery>

        <InsulatingCompositionText>
          <TextLine>
            <LargeTextLight>*</LargeTextLight>
            <BodyText>
              Цементный камень, извлеченный из оборудования для тестирования
              цементных растворов{" "}
              <StyledLink to={"/products/true-sight"}>True Sight</StyledLink>{" "}
              разработки ООО “ИРТ”
            </BodyText>
          </TextLine>
        </InsulatingCompositionText>
      </InsulatingCompositionSection>

      <EquipmentSection id="equipment">
        <SectionHeaderSemibold>наше оборудование</SectionHeaderSemibold>
        <EquipmentContainer>
          <EquipmentCard>
            <EquipmentPicture $image={hydraulics}>
              <img
                src={hydraulics}
                alt="Гидравлический агрегат"
                loading="lazy"
                decoding="async"
              />
            </EquipmentPicture>
            <EquipmentCardTextBox>
              <MediumHeader>Гидравлический агрегат</MediumHeader>
              <EquipmentCardText>
                <EquipmentCardTextline>
                  <BodyText>★</BodyText>
                  <BodyText>Закачка под давлением до 1080 атм</BodyText>
                </EquipmentCardTextline>
                <EquipmentCardTextline>
                  <BodyText>★</BodyText>
                  <BodyText>Высокая скорость закачки</BodyText>
                </EquipmentCardTextline>
                <EquipmentCardTextline>
                  <BodyText>★</BodyText>
                  <BodyText>Точный объем закачки и контроль давления</BodyText>
                </EquipmentCardTextline>
              </EquipmentCardText>
            </EquipmentCardTextBox>
          </EquipmentCard>

          <AdvantagesCard>
            <MediumHeader>Преимущества</MediumHeader>
            <Advantage>
              <span>
                <IconBolt />
              </span>
              <BodyText>
                Мобильность — оборудование не требует большого количества
                персонала в обслуживании, его можно быстро мобилизовать на
                объект проведения работ.{" "}
              </BodyText>
            </Advantage>
            <Advantage>
              <span>
                <IconChart />
              </span>
              <BodyText>
                Оборудование дает возможность проводить опрессовку межкольцевого
                пространства с записью динамики набора межколонного давленияи
                падения давления.
              </BodyText>
            </Advantage>
          </AdvantagesCard>

          <EquipmentCard>
            <EquipmentPicture $image={pneumatics}>
              <img
                src={pneumatics}
                alt="Пневматический агрегат"
                loading="lazy"
                decoding="async"
              />
            </EquipmentPicture>
            <EquipmentCardTextBox>
              <MediumHeader>Пневматический агрегат</MediumHeader>
              <EquipmentCardText>
                <EquipmentCardTextline>
                  <BodyText>★</BodyText>
                  <BodyText>
                    Система с нулевой зоной смешения в скважине
                  </BodyText>
                </EquipmentCardTextline>
                <EquipmentCardTextline>
                  <BodyText>★</BodyText>
                  <BodyText>
                    Продавка воздухом или опрессовка до 250 атм
                  </BodyText>
                </EquipmentCardTextline>
              </EquipmentCardText>
            </EquipmentCardTextBox>
          </EquipmentCard>
        </EquipmentContainer>
      </EquipmentSection>

      <PatentSection id="patents">
        <ImageGallery
          images={[
            {
              src: patent1,
              alt: "Патент на способ проведения ремонтоно-изоляционных работ в скважине ООО ИРТ",
            },
            {
              src: patent2,
              alt: "Патент на способ проведения ремонтоно-изоляционных работ нефтяных и газовых скважин ООО ИРТ",
            },
          ]}
        >
          {({ openGallery }) => (
            <Patents>
              <Patent $image={patent1} onClick={() => openGallery(0)}>
                <img
                  src={patent1}
                  alt="Патент на способ проведения ремонтоно-изоляционных работ в скважине ООО ИРТ"
                  loading="lazy"
                  decoding="async"
                />
              </Patent>
              <Patent $image={patent2} onClick={() => openGallery(1)}>
                <img
                  src={patent2}
                  alt="Патент на способ проведения ремонтоно-изоляционных работ нефтяных и газовых скважин ООО ИРТ"
                  loading="lazy"
                  decoding="async"
                />
              </Patent>
            </Patents>
          )}
        </ImageGallery>

        <PatentInnerContainer>
          <MediumHeaderBold>
            Запатентованные технологии проведения ремонтно-изоляционных работ
          </MediumHeaderBold>
          <PatentTextContainer>
            <BodyText>
              Мы не просто применяем лучшие мировые практики — мы создаём
              собственные.{" "}
            </BodyText>
            <BodyText>
              На сегодняшний день компания является патентообладателем двух
              уникальных способов проведения ремонтно-изоляционных работ в
              нефтяных и газовых скважинах. Наши технологии позволяют сократить
              сроки ликвидации осложнений и снизить риски при строительстве и
              ремонте скважин.
            </BodyText>
            <BodyText>
              Оба решения — наш вклад в технологическую эффективность и
              безопасность нефтегазовой добычи.
            </BodyText>
          </PatentTextContainer>

          <CTAContainer>
            <Button variant="arrow" onClick={scrollToApplication}>
              Связаться с нами
            </Button>
          </CTAContainer>
        </PatentInnerContainer>
      </PatentSection>

      <WorksSection id="work-examples">
        <Heading>
          <SectionHeaderSemibold>
            Примеры выполненных работ
          </SectionHeaderSemibold>
          <PageSubheader>Регион Ямал</PageSubheader>
        </Heading>
        <WorkExamples>
          <WorkExample>
            <WorkExamplePictureContainer>
              <ImageGallery
                images={[
                  {
                    src: example1,
                    alt: "График закачанных жидкостей Пример 1",
                  },
                ]}
              >
                {({ openGallery }) => (
                  <WorkExamplePicture
                    $image={example1}
                    onClick={() => openGallery(0)}
                  >
                    <img
                      src={example1}
                      alt="График закачанных жидкостей Пример 1"
                      loading="lazy"
                      decoding="async"
                    />
                  </WorkExamplePicture>
                )}
              </ImageGallery>
            </WorkExamplePictureContainer>
            <WorkExampleInner>
              <WorkExampleHeading>
                <MediumHeader>Уренгойское месторождение</MediumHeader>
                <h1>01</h1>
              </WorkExampleHeading>
              <ExampleBody>
                <ProblemHeader>
                  <IconWarning />
                  <BodyTextBold>Проблема</BodyTextBold>
                </ProblemHeader>
                <ProblemInnerContainer>
                  <BodyText>
                    Негерметичность муфты при гидравлическом разрыве пласта.{" "}
                    <br />
                    Нет возможности проведения дальнейшей работы для запуска
                    скважины.
                  </BodyText>
                </ProblemInnerContainer>
              </ExampleBody>
              <ExampleBody>
                <SolutionHeader>
                  <IconCheckDarkGreen />
                  <BodyTextBold>Решение</BodyTextBold>
                </SolutionHeader>
                <SolutionInnerGrid>
                  <SolutionInnerContainer>
                    <span>
                      <MediumHeader>1</MediumHeader>
                    </span>
                    <BodyText>
                      Дизайн работы с расчетом зоны смешения в собственном ПО{" "}
                      <StyledLink to={"/products/cemlife"}>CemLife</StyledLink>
                    </BodyText>
                  </SolutionInnerContainer>
                  <SolutionInnerContainer>
                    <span>
                      <MediumHeader>2</MediumHeader>
                    </span>
                    <BodyText>
                      Подбор рецептуры при помощи интеллектуального поиска
                      системы автоматизации лаборатории{" "}
                      <StyledLink to={"/products/cemtest"}>CemTest</StyledLink>
                    </BodyText>
                  </SolutionInnerContainer>
                  <SolutionInnerContainer>
                    <span>
                      <MediumHeader>3</MediumHeader>
                    </span>
                    <BodyText>
                      Закачка полимерной смолы через НКТ <br />
                      V=2,2 м<sup>3</sup> <br />γ = 1.1 г/см<sup>3</sup>
                    </BodyText>
                  </SolutionInnerContainer>
                  <SolutionInnerContainer>
                    <span>
                      <MediumHeader>4</MediumHeader>
                    </span>
                    <BodyText>Опрессовка на 900 атм</BodyText>
                  </SolutionInnerContainer>
                </SolutionInnerGrid>
              </ExampleBody>
            </WorkExampleInner>
          </WorkExample>

          <WorkExample>
            <WorkExampleInner>
              <WorkExampleHeading>
                <MediumHeader>Северо-Самбургское месторождение</MediumHeader>
                <h1>02</h1>
              </WorkExampleHeading>
              <ExampleBody>
                <ProblemHeader>
                  <IconWarning />
                  <BodyTextBold>Проблема</BodyTextBold>
                </ProblemHeader>
                <ProblemInnerContainer>
                  <BodyText>
                    Авария при подъеме гибкой насосной-компрессорной трубы,
                    наличие межколонного давления 370 ат.
                  </BodyText>
                </ProblemInnerContainer>
              </ExampleBody>
              <ExampleBody>
                <SolutionHeader>
                  <IconCheckDarkGreen />
                  <BodyTextBold>Решение</BodyTextBold>
                </SolutionHeader>
                <SolutionInnerGridThree>
                  <SolutionInnerContainer>
                    <span>
                      <MediumHeader>1</MediumHeader>
                    </span>
                    <BodyText>
                      Дизайн работы с расчетом зоны смешения в собственном ПО{" "}
                      <StyledLink to={"/products/cemlife"}>CemLife</StyledLink>
                    </BodyText>
                  </SolutionInnerContainer>
                  <SolutionInnerContainer>
                    <span>
                      <MediumHeader>2</MediumHeader>
                    </span>
                    <BodyText>
                      Подбор рецептуры при помощи интеллектуального поиска
                      системы автоматизации лаборатории{" "}
                      <StyledLink to={"/products/cemtest"}>CemTest</StyledLink>
                    </BodyText>
                  </SolutionInnerContainer>
                  <SolutionInnerContainer>
                    <span>
                      <MediumHeader>3</MediumHeader>
                    </span>
                    <BodyText>
                      Установка моста через гибкую насосной-компрессорную трубу
                      из полимерной смолы <br />
                      V=1 м<sup>3</sup> <br />γ = 1.07 г/см<sup>3</sup>
                    </BodyText>
                  </SolutionInnerContainer>
                </SolutionInnerGridThree>
              </ExampleBody>
            </WorkExampleInner>
            <WorkExamplePictureContainer>
              <ImageGallery
                images={[
                  {
                    src: example3,
                    alt: "График закачанных жидкостей Пример 3",
                  },
                ]}
              >
                {({ openGallery }) => (
                  <WorkExamplePicture
                    $image={example3}
                    onClick={() => openGallery(0)}
                  >
                    <img
                      src={example3}
                      alt="График закачанных жидкостей Пример 3"
                      loading="lazy"
                      decoding="async"
                    />
                  </WorkExamplePicture>
                )}
              </ImageGallery>
            </WorkExamplePictureContainer>
          </WorkExample>
        </WorkExamples>
      </WorksSection>

      <ApplicationFooter />
    </Container>
  );
};

export default RepairWorks;
